export default (to, from, next) => {
  /*validateSession().then((token) => {
    if (token) {
      next({ name: 'home' })
    } else {
      next()
    }
  })*/
}



// WEBPACK FOOTER //
// ./src/router/middleware/guest.js